import {SmsSettings, UserSettings} from "modules/user_settings/model/UserSettings";
import {ToneOptionBlock} from "modules/user_settings/component/email-settings/left-side/left-side";


export let initialiseEmailToneOption = (userSettings: UserSettings) : Array<ToneOptionBlock>  => [
    {
        groupName: "professionalismToneConfig",
        toneOptions: [
            { label: "Friendly", value: "FRIENDLY" },
            { label: "Professional", value: "PROFESSIONAL" }
        ],
        selectedValue: userSettings.professionalismToneConfig,
    },
    {
        groupName: "enthusiasticToneConfig",
        toneOptions: [
            { label: "Enthusiastic", value: "ENTHUSIASTIC" },
            { label: "Neutral", value: "NEUTRAL" }
        ],
        selectedValue: userSettings.enthusiasticToneConfig,
    },
    {
        groupName: "persuasiveToneConfig",
        toneOptions: [
            { label: "Persuasive", value: "PERSUASIVE" },
            { label: "Informative", value: "INFORMATIVE" }
        ],
        selectedValue: userSettings.persuasiveToneConfig,
    },
    {
        groupName: "urgencyToneConfig",
        toneOptions: [
            { label: "Urgent", value: "URGENT" },
            { label: "Non-Urgent", value: "NON_URGENT" }
        ],
        selectedValue: userSettings.urgencyToneConfig,
    },
    {
        groupName: "personalisationConfig",
        toneOptions: [
            { label: "High Personalization", value: "HIGH_PERSONALISATION" },
            { label: "Low Personalization", value: "LOW_PERSONALISATION" }
        ],
        selectedValue: userSettings.personalisationConfig,
    }
];

export let initialiseSmsToneOption = (userSettings: SmsSettings) : Array<ToneOptionBlock>  => [
    {
        groupName: "professionalismToneConfig",
        toneOptions: [
            { label: "Friendly", value: "FRIENDLY" },
            { label: "Professional", value: "PROFESSIONAL" }
        ],
        selectedValue: userSettings.professionalismToneConfig,
    },
    {
        groupName: "enthusiasticToneConfig",
        toneOptions: [
            { label: "Enthusiastic", value: "ENTHUSIASTIC" },
            { label: "Neutral", value: "NEUTRAL" }
        ],
        selectedValue: userSettings.enthusiasticToneConfig,
    },
    {
        groupName: "persuasiveToneConfig",
        toneOptions: [
            { label: "Persuasive", value: "PERSUASIVE" },
            { label: "Informative", value: "INFORMATIVE" }
        ],
        selectedValue: userSettings.persuasiveToneConfig,
    },
    {
        groupName: "urgencyToneConfig",
        toneOptions: [
            { label: "Urgent", value: "URGENT" },
            { label: "Non-Urgent", value: "NON_URGENT" }
        ],
        selectedValue: userSettings.urgencyToneConfig,
    }
];
